import { Box, styled, Typography } from '@mui/material';

export const LineupSidebarContainer = styled(Box)`
  width: 100%;
`;

export const LineupSidebarWrapper = styled(Box)`
  padding: 1.25rem 0 0 0;
`;

export const LineupContainer = styled(Box)`
  margin: 0.625rem 0;
  user-select: none;
`;

export const SortableItemContainer = styled('div')(
  ({ theme }) => `
  &.dragged {
    z-index: 1200; // to override Mui drawer of 1200
    background-color: ${theme.palette.common.white} ;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  }
  `,
);

export const BackupContainer = styled(Box)`
  margin-top: 1rem;
`;

export const HeaderTitle = styled(Typography)(
  () => `
      font-weight: 400;
      font-size: 18px;
      `,
);
